<template>
  <transition name="fade">
    <div
      class="my-overlay"
    >
      <v-layout
        align-center
        justify-center
        fill-height
        column
        light
      >
        <span class="headline font-weight-light white--text">{{ text }}</span>
        <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-layout>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      intervalTimer: false,
    };
  },
  created() {
    this.launchIntervalTimer();
  },
  beforeDestroy() {
    this.clearIntervalTimer();
  },
  components: {
  },
  computed: {
  },
  methods: {
    clearIntervalTimer() {
      if (!this.intervalTimer) return;
      clearInterval(this.intervalTimer);
    },
    launchIntervalTimer() {
      if (this.intervalTimer) return;
      this.intervalTimer = setInterval(() => this.getProject(), 30000);
    },
    async getProject() {
      try {
        await this.$projects.get(this.$route.params.id);
      } catch (err) {
        if (err.error === 'Project not found') {
          this.$router.push({ name: 'NotFound' });
        } else if (err.error === 'Content not found') {
          this.$router.push({ name: 'NotUploaded' });
        } else if (err.error === 'Site authentication failed') {
          this.$router.push({
            name: 'home',
            params: {
              project: this.$route.params.id,
              hint: 'Please provide site password',
            },
          });
        } else {
          logger.debug(err);
          const msg = err.error || err.message || err;
          this.readerError({
            title: 'Reader error',
            text: msg,
          });
        }
        return;
      }
    }
  },
};
</script>

<style scoped>
.my-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  background-color: rgba(0, 0, 0, 1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
